import { render, staticRenderFns } from "./InfoAccessible.vue?vue&type=template&id=63c4b49a&"
import script from "./InfoAccessible.vue?vue&type=script&lang=js&"
export * from "./InfoAccessible.vue?vue&type=script&lang=js&"
import style0 from "./InfoAccessible.vue?vue&type=style&index=0&id=63c4b49a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports